module.exports = __webpack_public_path__ + "static/media/ensure_cultural_fit.0251abea.svg";